<!--  -->
<template>
  <div class="home">
    <!-- <header>
      <span class="back" @click='back()'></span>
      <span>线路征集活动</span>
      <span class="more"></span>
    </header> -->

    <div class="banner" ref='banner'>
      <img src="../assets/images/images/dingzhilvyouxianlu.png" alt="" />
      <!-- <span class="num">已经有 {{tourSum}}人定制了线路</span> -->
    </div>
    <div class="map" v-show="showMap">
      <div class="cap addroad">
        <div id="container2" ref='container2'>
        </div>
        <div class="btn submit" @click="submitmyroad()" v-if="submitbtn">

          提交我的线路
        </div>
        <div class="btn submit2" v-else-if="!submitbtn">
          <el-button type="primary" :loading="true">提交我的线路</el-button>
        </div>
      </div>
      <div id="panel"></div>
      <div class="layer" @click="closeMap()"></div>
    </div>
    <div class="main" ref='main'>
      <div class="box addroad">
        <ul>
          <li>
            <span>主题</span>
            <div>
              <nut-cell @click.native="openSwitch('isVisible')" :desc="option">
              </nut-cell>
              <nut-picker title="选择主题" :is-visible="isVisible" :list-data="listData" @close="closeSwitch('isVisible')" @confirm="confirm"></nut-picker>
            </div>
          </li>
          <li>
            <span>预估天数</span>
            <div class="select">
              <input type="number" v-model="address.tourTime" placeholder="请输入预估天数">
              <!-- <el-date-picker onfocus="this.blur()" v-model="address.tourTime" type="date" placeholder="选择出行时间" value-format="yyyy-MM-dd">
              </el-date-picker> -->
            </div>
          </li>
          <div>
            <li class="address" v-for='(item,index) in address.routes' :key="index">
              <span v-if='index==0'>出发地</span>
              <span v-else-if='index!=0 && index!=address.routes.length-1'>第{{index}}站</span>
              <span v-else-if='index==address.routes.length-1'>目的地</span>
              <i class="del" v-if='index!=0' @click="delroute(index)">
                删除
              </i>
              <i class="location" v-if='index==0'>
                location
              </i>
              <div class="select">
                <input type="text" @focus="inputFocus(index)" :ref='"input"+index' value="" :id="'keyword'+index" :name="'keyword'+index" v-model="address.routes[index]" placeholder="请输入路线" />
              </div>
            </li>
          </div>
          <li>
            <div class="button">
              <span class="add" @click="addroute()">添加目的地</span>
            </div>
          </li>
          <li>
            <span>线路描述</span>
            <div class="select">
              <textarea name="" id="" maxlength="500" placeholder="最多输入500字" v-model="address.description" cols="30" rows="5"></textarea>
            </div>
          </li>
          <div class="bt submit" @click="saveimg">
            生成线路
          </div>
          <!-- <div class="btn submit" @click="submitmyroad()" v-if="submitbtn">
            提交我的线路
          </div>
          <div class="btn submit" v-else-if="!submitbtn">
            提交我的线路
          </div> -->
        </ul>
      </div>

    </div>

    <div class="commap" v-if="mapShadow">
      <div class="map">
        <Bmap @getpoint='getpoint' ref='Bmap' :i="address.i" :center='center'></Bmap>
      </div>
      <div class="shadow" @click="closeShadow"></div>
      <div class="shadowbutton" @click="closeShadow">确认</div>
    </div>
    <el-dialog :visible.sync="logDialog" width="70%" title="" :show-close="false">
      <el-row>
        <p>请先登录</p>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="logDialog = false">取 消</el-button>
        <el-button size="small" type="danger" @click="login">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { API_1, Global } from "../conf/api";
import "../assets/css.css";
import Bmap from "../components/map";

import AMap from "AMap";
let Amap, marker;
import html2canvas from "html2canvas";
import VueAMap from "vue-amap";
export default {
  //import引入的组件需要注入到对象中才能使用
  name: "Home",
  components: {
    Bmap,
  },
  data() {
    //这里存放数据
    return {
      showMap: false,
      option: "请选择主题",
      isVisible: false,
      listData: [[]],
      mapShadow: false,
      logDialog: false,
      address: {
        i: 0,
        imageUrl: "",
        theme: [],
        themeval: "",
        description: "",
        tourTime: "",
        startProvince: "",
        startCity: "",
        longitude: "",
        latitude: "",
        userID: "",
        userName: "",
        userHeadImage: "",
        routes: ["", ""],
        tourRoutes: [
          {
            province: "",
            city: "",
            longitude: "",
            latitude: "",
            name: "",
            orderNum: "",
            tourID: "",
          },
        ],
      },
      token: "",
      userid: "",
      userimg: "",
      username: "",
      currtheme: "", //当前主题
      roadlist: [],
      capitals: [], //坐标组
      page: {
        currentPage: 0,
        count: 0,
        pageSize: 10,
      },
      voteSingleNum: 0,
      tourSum: 0, //多少人制定了线路
      submitbtn: true,
      center:[116.397428, 39.90923],//中心点坐标
    };
  },
  mounted() {
    // this.axios.post(API_1 + Global.addTour, {}).then((res) => {
    //   console.log(res, "111");
    // });

    //https://www.ccmapp.cn/middleware/userextrainfo?token=5f6c65896cf1b57504d4e5b2 //获取头像
    if (this.$route.query.address) {
      let address = this.$route.query.address;
      this.option = JSON.parse(address).themeval;
      this.address.themeval = JSON.parse(address).themeval;
      this.address.description = JSON.parse(address).description;
      this.address.tourTime = JSON.parse(address).tourTime;
      this.address.routes = JSON.parse(address).routes;
      this.address.tourRoutes = JSON.parse(address).tourRoutes;
    }
    this.init();
  },

  methods: {
    login() {
      this.$router.push({
        path: "/login",
        query: {
          platform: this.$route.query.platform,
          address: JSON.stringify(this.address),
        },
      });
    },
    async saveimg() {
      if(this.$route.query.needLog == "log") {
        this.logDialog = true;
        return false;
      }
      console.log(this.address.themeval);
      if (this.address.routes[0] == "") {
        this.$toast.text("请选择路线");
        return false;
      }

      if (this.address.themeval == "") {
        this.$toast.text("选择旅游线路主题");
        return false;
      }
      if (this.address.tourTime == "") {
        this.$toast.text("选择预估天数");
        return false;
      }
      this.submitbtn = false;
      this.showMap = true;
      window.scrollTo(0, 0);
      await this.initmap();
    },
    closeMap() {
      this.showMap = false;
    },
    initmap() {
      let that = this;
      let capitals = [];
      this.address.tourRoutes.map((res) => {
        if (res.longitude) {
          capitals.push({
            center: [res.longitude, res.latitude],
            content: res.name,
          });
        }
      });

      let start = capitals[0].center;
      let end = capitals[capitals.length - 1].center;
      let center = capitals.slice(1, capitals.length - 1);
      center.map((res, i, arr) => {
        arr[i] = new AMap.LngLat(res.center[0], res.center[1]);
      });
      console.log(capitals, center, "123");
      //基本地图加载
      var map = new AMap.Map("container2", {
        resizeEnable: true,
        center: [116.397428, 39.90923], //地图中心点
        zoom: 13, //地图显示的缩放级别
      });
      //构造路线导航类
      var driving = new AMap.Driving({
        map: map,
        panel: "panel",
      });
      // 加点儿

      for (let i = 0; i < capitals.length; i++) {
        marker = new AMap.Marker({
          position: capitals[i].center, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        });
        marker.setLabel({
          offset: new AMap.Pixel(10, 10), // 设置文本标注偏移量
          content: capitals[i].content, // 设置文本标注内容
          direction: "right", // 设置文本标注方位
        });
        marker.setMap(map);
      }
      console.log("222", start, end);
      // 根据起终点经纬度规划驾车导航路线
      driving.clear();
      driving.search(
        new AMap.LngLat(start[0], start[1]),
        new AMap.LngLat(end[0], end[1]),
        {
          waypoints: center,
        },
        function (status, result) {
          console.log("222333");

          // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
          if (status === "complete") {
            console.log("绘制驾车路线完成");
            setTimeout(function () {
              html2canvas(that.$refs.container2, {
                useCORS: true,
                x: 0,
                y: 150,
              }).then((canvas) => {
                let dataURL = canvas.toDataURL("image/png");
                // that.address.imageUrl = dataURL;
                that.submitbtn = true;
                let formData = new FormData();
                let selFile = that.dataURLtoFile(dataURL, "myname");
                formData.append("file", selFile);
                formData.append("token", "");
                that.axios
                  .post("https://api.ccmapp.cn/apis/file/upload", formData)
                  .then((res) => {
                    that.address.imageUrl = res.data.data.url;
                  });
                console.log(that.address.imageUrl, "111111111111111111111111");
                //this.layer = true;
                // this.$message("请长按保存!");
              });
            }, 1000);
          } else {
            console.log("获取驾车数据失败：" + result);
          }
        }
      );
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    openSwitch(param) {
      this[`${param}`] = true;
    },

    closeSwitch(param) {
      this[`${param}`] = false;
    },

    confirm(chooseData) {
      this.option = `${chooseData[0].value}`;
      this.address.themeval = chooseData[0].value;
    },
    async init() {
      let params = this.$route.query;
      this.token = params.token;
      await this.axios
        .get("https://www.ccmapp.cn/middleware/userextrainfo", {
        // .get("https://testapi.ccmapp.cn:15400/middleware/userextrainfo", {
          params: {
            token: this.token,
          },
        })
        .then((res) => {
          this.username = res.data.data.user.realname;
          this.userimg = res.data.data.user.photo;
          this.userid = res.data.data.user._id;
        });

      this.axios //主题获取
        // .get("http://172.10.103.61:15000/" + Global.themelist, {
        .get("https://api.ccmapp.cn/" + Global.themelist, {
          params: {
            token: this.token,
            type: "touristSoutes",
            system: 0,
            key: "",
            pagination: "eyJjdXJyZW50UGFnZSI6MSwicGFnZVNpemUiOjEwfQ",
            order: "-1",
            appid: "5e71964899aa8917f1e97c58",
          },
        })
        .then((res) => {
          console.log(res);
          this.address.theme = res.data.data.list;
          res.data.data.list.map((res, i) => {
            let obj = {};
            obj.label = i;
            obj.value = res.dictext;
            this.listData[0].push(obj);
          });
          // this.option = this.listData[0][0].value;
          //this.address.themeval = this.listData[0][0].value;
          this.address.theme.sort(function (a, b) {
            return a.order - b.order;
          });
        });

      this.listTour("", "", "");
      // this.gettournum();
    },
    closeShadow() {
      this.mapShadow = false;
    },
    inputFocus(i) {
      let $this=this;
      this.address.i = i;
      if(i>0){
        let route=this.address.tourRoutes[i-1];
         this.center=[route.longitude,route.latitude];
      }
      setTimeout(function(){
           $this.mapShadow = true;
      },0)
     // this.$refs.Bmap.inputFocus();
    },
    gettournum() {
      this.axios.get(API_1 + Global.tourSum, {}).then((res) => {
        this.tourSum = res.data.data;
      });
    },
    themelist(theme) {
      this.currtheme = theme;
      this.page.currentPage = 0;
      this.listTour("", theme, "");
    },
    currentchange(val) {
      //分页
      console.log(val);
      this.page.currentPage = val;
      this.listTour("", this.currtheme, "");
    },
    listTour(id, name, mine) {
      let params = {
        searchUserID: this.userid,
        searchTheme: name,
        searchMine: "",
        pageSize: this.page.pageSize,
        currentPage: this.page.currentPage,
      };
      this.axios
        .get(API_1 + Global.listTour, { params: params })
        .then((res) => {
          this.roadlist = res.data.data;
          this.page.count = res.data.count;
          console.log(res, this.roadlist, mine);
        });
    },
    vote(id) {
      this.axios
        .get(API_1 + Global.vote, {
          params: { id: id, userID: this.userid },
        })
        .then((res) => {
          console.log(res, "vote");
          this.voteSingleNum++;
          localStorage.setItem("voteSingleNum", this.voteSingleNum);
          this.listTour("", this.currtheme, "");
        });
    },
    share(tid) {
      this.axios
        .get(API_1 + Global.share, {
          params: { userID: this.userid, tourID: tid },
        })
        .then((res) => {
          console.log(res, "share");
          if (res.data.code == 200) {
            console.log(this.roadlist, "lis");
            this.roadlist.map((item) => {
              if (item.id == tid) {
                console.log(item);
                let title = "";
                item.tourRoutes.map((i) => {
                  title += i.name + "-";
                });
                window.location.href =
                  "/roadmap?option=share&shareDescription=" +
                  item.description +
                  "&shareImage=https://testapi.ccmapp.cn/apis/file/dl/source/5f7157b3c182cd5ca4ab5e22.png&shareTitle=" +
                  title +
                  // "&shareUrl=https://apps.ccmapp.cn/dist#/roadmap?tourid=" +
                  "&shareUrl=https://apps.ccmapp.cn/dist/jump.html?tourid=" +
                  tid +
                  "&currentPage=" +
                  this.page.currentPage +
                  "$theme=" +
                  this.currtheme;
              }
            });
          }
        });
    },
    toimg() {},
    clearRoutes() {
      this.address.themeval = "";
      this.address.tourTime = "";
      this.address.description = "";
      this.address.tourRoutes = {
        province: "",
        city: "",
        longitude: "",
        latitude: "",
        name: "",
        orderNum: "",
        tourID: "",
      };
    },
    submitmyroad() {
      console.log(this.token, this.address);
      // if (this.token == undefined || !this.token) {
      //   localStorage.setItem("message", JSON.stringify(this.address));
      //   window.location.href = "/log?option=needlogin";
      //   this.$message("请先登录");
      //   return false;
      // }

      if (this.address.routes[0] == "") {
        this.$toast.text("请选择路线");
        return false;
      }
      if (this.address.themeval == "") {
        this.$toast.text("选择旅游线路主题");
        return false;
      }
      this.submitbtn = false;

      this.axios
        .post(API_1 + Global.addTour, {
          theme: this.address.themeval,
          tourDay: this.address.tourTime,
          imageUrl: this.address.imageUrl, //图片url
          description: this.address.description,
          startProvince: this.address.tourRoutes[0].province,
          startCity: this.address.tourRoutes[0].name,
          longitude: this.address.tourRoutes[0].longitude,
          latitude: this.address.tourRoutes[0].latitude,
          userID: this.userid, //用户id
          userName: this.username, //用户名
          userHeadImage: this.userimg, //用户头像
          tourRoutes: this.address.tourRoutes,
        })
        .then((res) => {
          console.log(res, "111");
          if (res.data.code == 200) {
            this.submitbtn = true;
            this.$toast.text("提交成功");
            this.listTour("", "", "");
            localStorage.removeItem("message");
            this.myroad();
          } else {
            this.$toast.text(res.data.message)
          }
        });
    },
    setval() {
      // console.log(this.address.routes);
    },
    delroute(i) {
      this.address.routes.splice(i, 1);
      this.address.tourRoutes.splice(i, 1);
    },
    addroute() {
      if (this.address.routes[this.address.routes.length - 1] != "") {
        this.address.routes.push("");
        this.address.tourRoutes.push({
          province: "",
          city: "",
          longitude: "",
          latitude: "",
          name: "",
          orderNum: "",
          tourID: "",
        });
      } else {
        this.inputFocus(this.address.routes.length - 1);
      }

      console.log(this.address.tourRoutes);
    },
    back() {
      this.$router.go(-1);
    },
    add() {
      this.address.tourRoutes.map((res) => {
        this.capitals.push({
          center: [res.longitude, res.latitude],
          content: res.name,
        });
      });
      let capitals = this.capitals;
      console.log(this.capitals, this.address.tourRoutes, "capitals");

      //   this.capitals.push({});
      //   this.capitals[i].center = [e.poi.location.lng, e.poi.location.lat];
      //   this.capitals[i].content = "<div class = 'area'>" + e.poi.name + "</div>";
      //   this.add();
      //   let capitals = [
      //     {
      //       center: [116.524436, 39.923176],
      //       content: "<div class = 'area'>景点一</div>",
      //     },
      //     {
      //       center: [118.46947, 40.00212],
      //       content: "<div class = 'area'>景点二</div>",
      //     },
      //     {
      //       center: [112.324351, 35.96644],
      //       content: "<div class = 'area'>景点三</div>",
      //     },
      //     {
      //       center: [115.458678, 36.892771],
      //       content: "<div class = 'area'>景点四4</div>",
      //     },
      //     {
      //       center: [116.800742, 39.0],
      //       content: "<div class = 'area'>景点五</div>",
      //     },
      //     {
      //       center: [116.342891, 39.804469],
      //       content: "<div class = 'area'>景点六</div>",
      //     },
      //     {
      //       center: [116.525611, 40.737687],
      //       content: "<div class = 'area'>景点7</div>",
      //     },
      //   ];
      // 创建一个 Marker 实例：
      for (let i = 0; i < capitals.length; i++) {
        marker = new AMap.Marker({
          position: capitals[i].center, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        });
        marker.setLabel({
          offset: new AMap.Pixel(10, 10), // 设置文本标注偏移量
          content: capitals[i].content, // 设置文本标注内容
          direction: "right", // 设置文本标注方位
        });
        marker.setMap(Amap);
      }

      let lineArr = new Array();
      capitals.map((val) => {
        lineArr.push(val.center);
      });
      //     }) lineArr.push(new AMap.LngLat(116.420087, 39.908374)); //第二个点
      // lineArr.push(new AMap.LngLat(116.432303, 39.909320)); //第三个点
      // lineArr.push(new AMap.LngLat(116.434679, 39.908769)); //第四个点
      // lineArr.push(new AMap.LngLat(116.434335, 39.924568)); //第五个点

      //绘制轨迹
      let polyline = new AMap.Polyline({
        // eslint-disable-line no-unused-vars
        path: lineArr,
        showDir: true,
        dirColor: "pink",
        strokeColor: "rgb(261,105,96)", // 线颜色
        strokeWeight: 10,
      });
      Amap.add(polyline);
      Amap.setFitView();
    },
    getpoint(address, point) {
      console.log(address, point, "mapaddress");
      this.address.routes[this.address.i] = point;
      this.address.tourRoutes[this.address.i] = address;
    },

    roaddetail(id) {
      this.$router.push({
        path: "/roadmap",
        query: {
          token: this.token,
          uid: this.userid,
          tourid: id,
          currentPage: this.page.currentPage,
          theme: this.currtheme,
        },
      });
    },
    myroad() {
      this.$router.push({
        path: "/myroad",
        query: {
          token: this.token,
          uid: this.userid,
        },
      });
    },
    prizeList() {
      let params = {};
      this.axios
        .get(API_1 + Global.list, {
          params: params,
        })
        .then((res) => {
          if (res.data.code == 200) {
            console.log(res.data.data);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
};
</script>
<style>
.nut-cell .nut-cell-left{ flex: 0;}
.nut-cell .nut-cell-right{ flex: 1;}
.amap-marker-label {
  padding: 5px 10px !important;
  border: 0 !important;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3) !important;
}
.amap-marker-label {
  border-radius: 10px;
}
#panel{ display: none;}
.home .map .cap{ position: fixed; width: 100%; left: 0; top: 150px; z-index: 999; background: #fff;}
.home .map .cap.addroad{ padding: 0px 0 15px 0; border-radius: 5px; overflow: hidden;}
.home .map .cap #container2{ margin-bottom: 15px;}
.home .map .layer{ position: fixed; width: 100%; height: 100vh; background: rgba(0,0,0,0.3); top: 0; left: 0; z-index:998;}
.cls{ clear: both;}
.address:last-child span:after{ display: none;}
.address span{position: relative;}
.address span:before{position: absolute; left: 15px; top: 50%; margin-top: -3px; display: block; content: ""; width: 7px; height: 7px; border-radius: 50%; background: #333;}
.address span:after{position: absolute; left: 18px; top: 20px; display: block; content: ""; width: 1px; height: calc(100% + 10px); border-left: 1px dashed #333;}
.el-input__prefix{ display: none;}
.el-input--prefix .el-input__inner{ padding-left: 10px;}
.nut-cell .nut-cell-box{ min-height: 37px;}
.nut-cell .nut-cell-title{ text-align: left; color: rgb(101,103,99);}
.el-date-editor input{ height: 37px; border: 0;
    background:rgb(235,251,241);
}
.addroad .submit{ width: 220px; height: 40px; border-radius: 4px; background: rgb(53,133,108); color: #fff; margin: 0 auto; line-height: 40px; text-align: center;}
.addroad .submit2 button{ background: rgb(53,133,108); color: #fff;}
.addroad .submit2{ text-align: center;}
.addroad li{ margin-bottom: 15px; position: relative;}
.addroad li:after{ display: block; content: ""; clear: both;}
.addroad li .del{ position: absolute; right: 5px; height: 38px; width: 20px;background: url(../assets/images/images/close.svg) center no-repeat; font-size: 0;}
.addroad li .location{ position: absolute; right: 5px; height: 38px; width: 20px;background: url(../assets/images/images/location-icon.svg) center no-repeat; font-size: 0;}

.addroad li > span{ display: block; float: left; width: 75px; line-height: 40px; font-weight: bold; text-align: right; padding-right: 10px;}
.addroad li > div{ width: calc(100% - 75px); float: left;}
.addroad li > div.select input{ height: 38px; background:rgb(235,251,241); width: 100%; color: rgb(101,103,99); padding:0 30px 0 10px; border-radius: 4px;}
.addroad li > div.select textarea{  background:rgb(235,251,241); width: 100%; color: rgb(101,103,99); padding:5px 0px 0 5px; border-radius: 4px;}
.addroad .button {
    width: calc(100% - 75px);
    margin: 0 0px 0 75px;
    height: 36px;
    border-radius: 10px;
    border: 1px dashed rgb(125,177,159);
    background:rgb(233,242,239);
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgb(125,177,159);
    line-height: 36px;}
.box{ background:url(../assets/images/images/border-mid.png) scroll 0 20px repeat-y #fff; background-size: contain; margin: 15px 0;
 position: relative; padding: 0 10px;}
.box:before{ position: absolute; display: block; content: ""; height: 14px; width: 100%; top: -14px; left: 0; background:url(../assets/images/images/border-top.png) top no-repeat #fff; background-size: 100% 14px; border-radius: 5px 5px 0 0;}
.box:after{ position: absolute; display: block; content: ""; height: 15px; width: 100%; bottom: -15px; left: 0; background:url(../assets/images/images/border-bottom.png) top no-repeat #fff; background-size: contain; border-radius: 0 0 5px 5px;}
.addroad{ padding: 15px 15px;}
.nut-cell {
  background: rgb(235,251,241) !important;
  height: 37px !important;
  border-radius: 4px;
}
.nut-cell-title {
  height: 40px;
  line-height: 40px !important;
}
.nut-picker-control span {
  line-height: 40px !important;
}
.nut-picker-control span.nut-picker-cancel-btn {
  padding-left: 10px;
}
.main .section_vote .list ul li .bottom {
  position: inherit;
}
.main .section_road .list2 ul li .el-select span {
  height: 40px;
}
.auto-item {
  color: #000;
}
#container2 {
  width: 100%;
  height: 40vh;
}
.home .btn img,
.home .myroad img {
  width: 190px;
}
.commap {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 99;
}
.commap .map {
  position: relative;
  z-index: 99;
}
.commap .shadowbutton {
  position: fixed;
  width: 150px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: rgb(216, 182, 96);
  left: 50%;
  margin-left: -75px;
  z-index: 99;
  top: 100px;
  color: #fff;
  font-size: 16px;
  border-radius: 15px;
  box-shadow: 0 0 3 rgba(0, 0, 0, 0.2);
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  left: 0;
  top: 0;
  z-index: 9;
}
.amap-icon {
  width: 5vw;
}
</style>
